

var _fn = require('xo-guest-components/src/fraudnet/fn');

define(['angular', 'squid/index', 'text!./template.html', 'components/xo-ui-components/src/spinner/directive', 'components/xo-page-components/src/merchant-header/directive', 'components/xo-page-components/src/header/directive', 'components/xo-page-components/src/footer/directive', 'components/xo-page-components/src/cart/directive', 'components/xo-ui-components/src/error-tooltip/directive', 'components/xo-validation/dist/directive', 'components/xo-device-info/dist/index', 'components/xo-models/src/shippingMethod/index'], function (angular, squid, template) {

    return angular.module('hermes.page.xo-checkout.directive', ['squid', 'xo-spinner.directive', 'xo-merchant-header.directive', 'xo-header.directive', 'xo-footer.directive', 'xo-cart.directive', 'xo-error-tooltip.directive', 'xo-validation.directive', 'xo-device-info']).directive('xoCheckout', function ($document, $config, $util) {

        return {
            template: template,
            scope: {},

            controller: function controller($scope, $rootScope, $state, $renderContent, $locale, $LocaleResolver, $DeviceInfo, $FallbackError, $feature, $populate, $CheckoutAppDataModel, $CheckoutCartModel, $CheckoutPayeeModel, $ShippingRuleSummaryModel) {

                $scope.token = $rootScope.token;
                $scope.locale = $locale;

                _fn.$fn.trigger();

                function setLanguageToggleFlags() {
                    var landingPage = $scope.checkoutAppData.get('flags.landing_page');
                    var hermesLoginRedirectParam = $util.param('hermesLoginRedirect');
                    var languageToggleFeature = $feature('languageToggle');

                    // Language Toggle - header
                    if (landingPage === 'BILLING' && !hermesLoginRedirectParam) {
                        $scope.languageSwitchHeader = { show: languageToggleFeature };
                    } else {
                        $scope.languageSwitchFooter = { show: languageToggleFeature };
                    }
                }

                function checkShippingRulesExist() {
                    return $populate($scope, {
                        shippingRulesSummary: $ShippingRuleSummaryModel.instance($rootScope.token).retrieve({
                            params: {
                                merchant_id: $scope.checkoutPayee.merchant.id,
                                currency_code: $scope.checkoutCart.purchase.amounts.total.currency_code
                            }
                        })
                    });
                }

                $populate($scope, {
                    checkoutAppData: $CheckoutAppDataModel.instance($scope.token),
                    checkoutCart: $CheckoutCartModel.instance($scope.token),
                    checkoutPayee: $CheckoutPayeeModel.instance($scope.token)
                }).then(function () {
                    setLanguageToggleFlags();

                    var isWpsFlow = $scope.checkoutAppData.doec_on_approve();
                    if (isWpsFlow) {
                        checkShippingRulesExist().then(function () {
                            if ($scope.shippingRulesSummary && $scope.shippingRulesSummary.isSnTEnabled || $scope.checkoutCart.instantUpdateIntegration) {
                                // preserve these cart amount values passed from the merchant
                                // since they could get changed after SnT from profile/callback (in case instant update) is applied
                                $scope.buttonParams = {
                                    shipping: $scope.checkoutCart.purchase.amounts.shipping,
                                    tax: $scope.checkoutCart.purchase.amounts.tax,
                                    total: $scope.checkoutCart.purchase.amounts.total
                                };
                            }
                        });
                    }
                });

                // Change html dir attribute for RTL/LTR, append RTL styling if needed.
                function setDirectionality() {
                    $document.prop('documentElement').setAttribute('dir', $locale.metadata.directionality);
                }

                // Change html lang attribute and document title
                function localizeHead() {
                    $document.prop('documentElement').setAttribute('lang', $locale.lang);
                    setDirectionality();

                    var content = $renderContent('base.payPal');

                    if (content) {
                        $document.title = content;
                    }
                }

                function getPaymentMethod() {
                    var paymentMethodViaUrl = $util.param('paymentMethod');
                    var paymentMethodViaCheckoutAppData = $scope.checkoutAppData.get('user_selected_funding_source_type') === 'PAY_UPON_INVOICE' ? 'invoice' : undefined;

                    return paymentMethodViaCheckoutAppData || paymentMethodViaUrl;
                }

                function checkUnbranded() {
                    var paymentMethod = getPaymentMethod();

                    if (!paymentMethod || !config.allowedUnbrandedPayments) {
                        // eslint-disable-line block-scoped-var, no-undef
                        return false;
                    }

                    // If paymentMethod in URL is NOT in the list of allowed payment methods, return false
                    if ($config.allowedUnbrandedPayments.indexOf(paymentMethod) === -1) {
                        return false;
                    }

                    return true;
                }

                $scope.isUnbranded = checkUnbranded();

                $scope.paymentMethod = '';

                if ($scope.isUnbranded) {
                    $scope.paymentMethod = getPaymentMethod();

                    if ($scope.paymentMethod === 'invoice') {
                        $scope.unbrandedTitle = 'payUponInvoice.header';
                        $scope.unbrandedSubTitle = 'payUponInvoice.processedBy';
                    }
                }

                $scope.isApp = $DeviceInfo.isApp();

                var contentChange = $rootScope.$on('contentChange', localizeHead);

                localizeHead();

                var cancel = $rootScope.$on('allLoaded', function () {
                    angular.element('#preloaderSpinner').hide();
                    cancel();
                });

                $scope.$on('localeChange', function () {
                    localizeHead();
                    setLanguageToggleFlags();
                });

                $scope.$on('$destroy', function () {
                    cancel();
                    contentChange();
                });

                $document.bind('click', function (event) {
                    $scope.$broadcast('clickBody', event.target);
                });
            }
        };
    });
});

_fn.$fn;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-checkout/directive.js
// module id = ./pages/xo-checkout/directive.js
// module chunks = 1